import { render } from "./MenuSet.vue?vue&type=template&id=0662102c&scoped=true"
import script from "./MenuSet.vue?vue&type=script&lang=js"
export * from "./MenuSet.vue?vue&type=script&lang=js"

import "./MenuSet.vue?vue&type=style&index=0&id=0662102c&scoped=true&lang=css"
import "./MenuSet.vue?vue&type=style&index=1&id=0662102c&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0662102c"]])

export default __exports__